import { DealAPIData, DealUIObject } from './types';

export function mapDealsToUIObjects(deals: DealAPIData[]): DealUIObject[] {
    return deals.reduce<DealUIObject[]>((acc, deal) => {
        const isCoupon = !!deal.attributes.coupon_code;

        const endsAt = new Date(deal.attributes.ends_at).getTime();
        const now = new Date().getTime();
        const timeDiff = endsAt - now;

        if (timeDiff <= 0) {
            return acc;
        }

        let expirationMessage = '';
        if (timeDiff <= 24 * 60 * 60 * 1000) {
            expirationMessage = `Ends in ${Math.floor(timeDiff / (60 * 60 * 1000))} hours`;
        } else if (timeDiff <= 48 * 60 * 60 * 1000) {
            expirationMessage = 'Ends tomorrow';
        } else if (timeDiff <= 7 * 24 * 60 * 60 * 1000) {
            expirationMessage = `Ends in ${Math.floor(timeDiff / (24 * 60 * 60 * 1000))} days`;
        }

        const ctaLabel = isCoupon ? 'Shop Coupon' : 'Shop Deal';

        try {
            if (deal.attributes.brand_id) {
                acc.push({
                    id: deal.id,
                    header: isCoupon ? 'Online Coupon' : 'Online Deal',
                    title: deal.attributes.label,
                    earnings: '', // earningsText?
                    expirationMessage,
                    ctaLabel,
                    couponCode: deal.attributes.coupon_code || undefined,
                    startAt: deal.attributes.starts_at,
                    endAt: deal.attributes.ends_at,
                    sortScore: Number(deal.attributes.rank),
                    url: deal.attributes.url,
                    dealType: isCoupon ? 'coupon' : 'deal',
                    affiliateId: deal.attributes.brand_id.toString(),
                });
            }
        } catch (e) {
            console.error(e);
        }

        return acc;
    }, [] as DealUIObject[]);
}
